// 디자인 외주 마켓 홍보 랜딩 (/promo/design) — 대표 지시 2026-08-24
// 기존 대문(PublicHome)은 그대로 두고, 대표가 카톡·QR·배너 홍보에 따로 쓰는 별도 페이지.
// 시안: 아티팩트 '덴탈클러스터 디자인 마켓' (2026-08-24) — 운영 웹 토큰(#6366F1·슬레이트) 그대로.
// 카피 원칙: 실제 구현된 기능만 약속(환자명 마스킹·파일 자동 왕복·명세서/계산서 연결·영문 인보이스).
// [대괄호]는 실측치 확정 후 채울 자리 — 지어내지 않는다.
import React from 'react';
import { BIZ_ADDRESS } from './common/SiteFooter';

const CSS = `
  .dmp { margin: 0; background: #ffffff; color: #0F172A; font-family: 'Noto Sans KR', -apple-system, 'Apple SD Gothic Neo', system-ui, sans-serif; line-height: 1.6; }
  .dmp a { color: #4338CA; text-decoration: none; }
  .dmp .wrap { max-width: 1120px; margin: 0 auto; padding: 0 24px; }
  .dmp .btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; border-radius: 12px; font-weight: 800; cursor: pointer; }
  .dmp .btn-primary { background: #6366F1; color: #fff; padding: 15px 28px; font-size: 16px; }
  .dmp .btn-primary:hover { background: #4F46E5; color: #fff; }
  .dmp .btn-ghost { background: #ffffff; color: #4338CA; border: 1.5px solid #C7D2FE; padding: 15px 28px; font-size: 16px; }
  .dmp .btn-ghost:hover { background: #EEF2FF; }
  .dmp .chip { display: inline-block; font-size: 12.5px; font-weight: 700; border-radius: 999px; padding: 4px 12px; }
  .dmp h1, .dmp h2 { margin: 0; letter-spacing: -0.8px; }
  .dmp .nav { position: sticky; top: 0; background: rgba(255,255,255,0.92); backdrop-filter: blur(8px); border-bottom: 1px solid #E2E8F0; z-index: 10; }
  .dmp .nav-in { display: flex; align-items: center; gap: 24px; padding: 14px 0; }
  .dmp .logo { display: flex; align-items: center; gap: 8px; font-size: 17px; font-weight: 900; color: #0F172A; }
  .dmp .nav-links { display: flex; gap: 22px; margin-left: auto; align-items: center; font-size: 14px; font-weight: 500; }
  .dmp .nav-links a { color: #475569; }
  .dmp .nav-cta { background: #6366F1; color: #fff !important; font-weight: 700; border-radius: 10px; padding: 9px 18px; }
  .dmp .hero { background: linear-gradient(180deg, #F5F7FF 0%, #ffffff 100%); }
  .dmp .hero-in { display: flex; gap: 56px; align-items: center; padding: 76px 0 64px; }
  .dmp .hero-copy { display: flex; flex-direction: column; gap: 20px; max-width: 590px; }
  .dmp .hero h1 { font-size: clamp(34px, 4.6vw, 52px); font-weight: 900; line-height: 1.22; }
  .dmp .hero p { margin: 0; font-size: 17px; color: #475569; line-height: 1.75; }
  .dmp .cards { display: flex; flex-direction: column; gap: 12px; flex: 1; min-width: 320px; }
  .dmp .case { background: #ffffff; border: 1px solid #E2E8F0; border-radius: 16px; padding: 18px 20px; display: flex; align-items: center; gap: 14px; box-shadow: 0 12px 32px rgba(15,23,42,0.07); }
  .dmp .case .ico { width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .dmp .case b { font-size: 14.5px; }
  .dmp .case small { display: block; font-size: 12.5px; color: #64748B; font-weight: 400; }
  .dmp .badge { font-size: 12px; font-weight: 700; border-radius: 8px; padding: 5px 10px; white-space: nowrap; margin-left: auto; }
  .dmp .strip { border-top: 1px solid #F1F5F9; border-bottom: 1px solid #F1F5F9; }
  .dmp .strip-in { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 28px; padding: 40px 0; }
  .dmp .strip h3 { margin: 0 0 4px; font-size: 15px; font-weight: 800; }
  .dmp .strip p { margin: 0; font-size: 13.5px; color: #64748B; line-height: 1.65; }
  .dmp .strip .item { display: flex; gap: 14px; align-items: flex-start; }
  .dmp .steps { padding: 72px 0; }
  .dmp .steps-head { text-align: center; margin-bottom: 36px; }
  .dmp .steps-head h2 { font-size: clamp(24px, 3vw, 32px); font-weight: 900; }
  .dmp .steps-head p { margin: 8px 0 0; font-size: 15px; color: #64748B; }
  .dmp .steps-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 24px; }
  .dmp .step { background: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 16px; padding: 28px; display: flex; flex-direction: column; gap: 10px; }
  .dmp .step .num { width: 34px; height: 34px; border-radius: 999px; background: #6366F1; color: #fff; font-size: 16px; font-weight: 800; display: flex; align-items: center; justify-content: center; }
  .dmp .step h3 { margin: 0; font-size: 17px; font-weight: 800; }
  .dmp .step p { margin: 0; font-size: 14px; color: #64748B; line-height: 1.7; }
  .dmp .paths { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px; padding-bottom: 72px; }
  .dmp .path { border-radius: 20px; padding: 40px; display: flex; flex-direction: column; gap: 14px; color: #fff; }
  .dmp .path .eyebrow { font-size: 12.5px; font-weight: 700; letter-spacing: 1px; }
  .dmp .path h3 { margin: 0; font-size: 24px; font-weight: 900; line-height: 1.4; }
  .dmp .path p { margin: 0; font-size: 14px; line-height: 1.75; }
  .dmp .path .go { background: #fff; font-size: 14px; font-weight: 800; border-radius: 10px; padding: 12px 22px; align-self: flex-start; margin-top: 6px; }
  .dmp .cta { background: #F5F7FF; border: 1.5px solid #C7D2FE; border-radius: 20px; padding: 44px 48px; display: flex; align-items: center; gap: 24px; margin-bottom: 72px; }
  .dmp .cta h2 { font-size: 26px; font-weight: 900; }
  .dmp .cta p { margin: 6px 0 0; font-size: 14.5px; color: #64748B; }
  .dmp .footer { border-top: 1px solid #E2E8F0; padding: 26px 0; font-size: 12px; color: #94A3B8; }
  .dmp .footer-row { display: flex; gap: 20px; flex-wrap: wrap; align-items: center; }
  .dmp .footer .legal { margin-top: 10px; font-size: 11.5px; color: #CBD5E1; }
  @media (max-width: 960px) { .dmp .hero-in { flex-direction: column; align-items: stretch; padding: 52px 0 44px; } }
  @media (max-width: 860px) { .dmp .nav-links a.hide-m { display: none; } }
  @media (max-width: 760px) {
    .dmp .strip-in, .dmp .steps-grid, .dmp .paths { grid-template-columns: 1fr; }
    .dmp .cta { flex-direction: column; align-items: flex-start; padding: 32px 26px; }
    .dmp .btn-row { flex-direction: column; align-items: stretch; }
  }
`;

const Tooth = ({ size = 22 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 3c-3 0-5 2-5 5 0 4 1.5 5 1.5 8 0 2 .8 5 2 5s1-2.5 1.5-4c.3-1 .7-1 1-1s.7 0 1 1c.5 1.5.5 4 1.5 4s2-3 2-5c0-3 1.5-4 1.5-8 0-3-2-5-5-5z" />
    </svg>
);

export default function DesignMarketPromo() {
    return (
        <div className="dmp">
            <style>{CSS}</style>
            {/* 상단 */}
            <div className="nav"><div className="wrap nav-in">
                <span className="logo">
                    <Tooth />
                    덴탈클러스터 <span className="chip" style={{ color: '#6366F1', background: '#EEF2FF', fontSize: 11.5, padding: '2px 8px', borderRadius: 6 }}>디자인 마켓</span>
                </span>
                <nav className="nav-links">
                    <a href="#dmp-how" className="hide-m">이용 안내</a>
                    <a href="#dmp-global" className="hide-m">해외 수주</a>
                    <a href="/login" style={{ color: '#0F172A', fontWeight: 700 }}>로그인</a>
                    <a href="/signup?type=lab" className="nav-cta">무료로 시작하기</a>
                </nav>
            </div></div>

            {/* 히어로 */}
            <div className="hero"><div className="wrap hero-in">
                <div className="hero-copy">
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <span className="chip" style={{ color: '#312E81', background: '#EEF2FF', border: '1px solid #C7D2FE' }}>국내 기공소 간 외주</span>
                        <span className="chip" style={{ color: '#064E3B', background: '#ECFDF5', border: '1px solid #A7F3D0' }}>해외 디자인 수주</span>
                    </div>
                    <h1>CAD 디자인 외주,<br />맡기고 받는 가장 빠른 길</h1>
                    <p>바쁠 때는 믿을 수 있는 기공소에 디자인을 맡기고, 여유가 있을 때는 국내·해외 물량을 수주하세요.<br />의뢰서 작성부터 파일 왕복, 검수, 거래명세서·계산서까지 한 흐름으로 이어집니다.</p>
                    <div className="btn-row" style={{ display: 'flex', gap: 12, marginTop: 4 }}>
                        <a href="/signup?type=lab" className="btn btn-primary">무료로 시작하기</a>
                        <a href="/signup?type=lab" className="btn btn-ghost">수주 프로필 만들기</a>
                    </div>
                    <div style={{ fontSize: 13, color: '#94A3B8' }}>가입·의뢰서 작성 무료 · 카드 등록 없이 시작</div>
                </div>
                <div className="cards">
                    <div className="case">
                        <span className="ico" style={{ background: '#EEF2FF' }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 17v3h16v-3" /><path d="M12 4v11" /><path d="M7 10l5 5 5-5" /></svg>
                        </span>
                        <div style={{ flex: 1 }}><b>김O수 · 크라운 #16 <span style={{ fontSize: 11.5, color: '#94A3B8', fontWeight: 500 }}>DO-260820-X9P</span></b><small>환자 실명은 전달되지 않습니다 — 가운데 O 처리</small></div>
                        <span className="badge" style={{ color: '#4338CA', background: '#EEF2FF' }}>확인해 주세요</span>
                    </div>
                    <div className="case">
                        <span className="ico" style={{ background: '#F1F5F9' }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>
                        </span>
                        <div style={{ flex: 1 }}><b>박O숙 · 브릿지 #14–#16</b><small>CAD 파일이 자동으로 전달됐습니다 · 납기 안내</small></div>
                        <span className="badge" style={{ color: '#475569', background: '#F1F5F9' }}>작업 중</span>
                    </div>
                    <div className="case">
                        <span className="ico" style={{ background: '#ECFDF5' }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                        </span>
                        <div style={{ flex: 1 }}><b>거래명세서 자동 연결</b><small>검수 완료 — 명세서·계산서가 자동으로 이어집니다</small></div>
                        <span className="badge" style={{ color: '#166534', background: '#DCFCE7' }}>완료</span>
                    </div>
                </div>
            </div></div>

            {/* 신뢰 3요소 */}
            <div className="strip"><div className="wrap strip-in">
                <div className="item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}><path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" /></svg>
                    <div><h3>환자정보를 넘기지 않는 외주</h3><p>환자 실명은 시스템에 저장되지 않고, 상대에게는 케이스번호와 가려진 이름만 전달됩니다.</p></div>
                </div>
                <div className="item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}><path d="M7 8l-4 4 4 4" /><path d="M17 8l4 4-4 4" /><path d="M3 12h18" /></svg>
                    <div><h3>CAD 파일 자동 왕복</h3><p>덴클 프로그램이 exocad·3Shape 케이스 폴더를 통째로 보내고, 완성 디자인을 받는 폴더에 되돌려 놓습니다.</p></div>
                </div>
                <div className="item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}><path d="M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2z" /><path d="M9 8h6" /><path d="M9 12h6" /></svg>
                    <div><h3>명세서·계산서까지 한 흐름</h3><p>수락하는 순간 거래명세서 초안이 만들어지고, 발행하면 전자(세금)계산서로 바로 이어집니다.</p></div>
                </div>
            </div></div>

            {/* 이용 순서 */}
            <div className="wrap steps" id="dmp-how">
                <div className="steps-head">
                    <h2>맡기는 쪽도, 받는 쪽도 세 단계</h2>
                    <p>전화·카톡·USB 없이, 의뢰부터 정산까지 화면 하나에서 끝납니다</p>
                </div>
                <div className="steps-grid">
                    <div className="step"><span className="num">1</span><h3>의뢰서를 보냅니다</h3><p>CAD 케이스 폴더를 고르면 치식·보철 종류·납기가 자동으로 채워집니다. 한 번에 10건까지.</p></div>
                    <div className="step"><span className="num">2</span><h3>디자이너가 작업합니다</h3><p>수락하면 파일이 자동으로 건너가고, 완성 STL과 CAD 원본이 되돌아옵니다. 수정 왕복(v1, v2)도 기록으로 남습니다.</p></div>
                    <div className="step"><span className="num">3</span><h3>검수하고 정산합니다</h3><p>확인을 누르면 거래명세서가 발행되고 전자(세금)계산서까지 이어집니다. 대금은 두 기공소가 직접 정산합니다.</p></div>
                </div>
            </div>

            {/* 국내 · 해외 */}
            <div className="wrap paths" id="dmp-global">
                <div className="path" style={{ background: '#312E81' }}>
                    <span className="eyebrow" style={{ color: '#C7D2FE' }}>국내 외주</span>
                    <h3>바쁜 주에는 맡기고,<br />한가한 주에는 받으세요</h3>
                    <p style={{ color: '#C7D2FE' }}>등록 기공소끼리의 디자인 외주만 중개합니다. 프로필에 단가표와 포트폴리오를 올리면 전국 기공소가 찾아옵니다.</p>
                    <a href="/signup?type=lab" className="go" style={{ color: '#312E81' }}>내 디자인 프로필 만들기</a>
                </div>
                <div className="path" style={{ background: '#064E3B' }}>
                    <span className="eyebrow" style={{ color: '#A7F3D0' }}>해외 수주</span>
                    <h3>해외 물량을<br />한국의 손기술로</h3>
                    <p style={{ color: '#A7F3D0' }}>영문 프로필·번역 채팅·영문 인보이스가 준비되어 있습니다. 임플란트·풀아치 같은 어려운 케이스일수록 한국 디자이너를 찾습니다.</p>
                    <a href="/signup?type=lab" className="go" style={{ color: '#064E3B' }}>해외 수주 알아보기</a>
                </div>
            </div>

            {/* CTA */}
            <div className="wrap"><div className="cta">
                <div style={{ flex: 1 }}>
                    <h2>오늘 첫 의뢰서를 보내보세요</h2>
                    <p>가입과 의뢰서 작성은 무료입니다. 프로그램 설치 없이 웹에서 바로 시작할 수 있습니다.</p>
                </div>
                <a href="/signup?type=lab" className="btn btn-primary" style={{ whiteSpace: 'nowrap' }}>무료로 시작하기</a>
            </div></div>

            {/* 푸터 */}
            <div className="footer"><div className="wrap">
                <div className="footer-row">
                    <span style={{ fontWeight: 700, color: '#64748B' }}>주식회사 덴탈클러스터</span>
                    <span>사업자등록번호 318-81-11805</span>
                    <span>주소 {BIZ_ADDRESS}</span>
                    <span style={{ marginLeft: 'auto' }}><a href="/terms" style={{ color: '#94A3B8' }}>이용약관</a> · <a href="/privacy" style={{ color: '#94A3B8' }}>개인정보처리방침</a></span>
                </div>
                <div className="legal">덴탈클러스터는 통신판매중개자로서 거래 당사자가 아니며, 디자인 용역의 당사자는 각 기공소입니다.</div>
            </div></div>
        </div>
    );
}
